export const vErrors = {
  has (errorsArray, name) {
    for (let i = 0; i < errorsArray.length; i++) {
      if (this.getItem(errorsArray[i], name)) {
        return true
      }
    }

    return false
  },
  hasMany (errorsArray, names) {
    for (let i = 0; i < names.length; i++) {
      const name = names[i]

      if (this.has(errorsArray, name)) {
        return true
      }
    }

    return false
  },
  first (errorsArray, name) {
    if (this.has(errorsArray, name)) {
      for (let i = 0; i < errorsArray.length; i++) {
        return this.getItem(errorsArray[i], name).msg
      }
    }

    return ''
  },
  getItem (bag, name) {
    if (!bag) {
      return undefined
    }

    return bag.items.find(e => e.field === name)
  },
  remove (errorsArray, name) {
    for (let i = 0; i < errorsArray.length; i++) {
      const bag = errorsArray[i]
      const itemIndex = bag.items.findIndex(e => e.field === name)
      if (itemIndex > -1) {
        return bag.items.splice(itemIndex, 1)
      }
    }
  }
}
